export default "__VITE_ASSET__abjBcS5X__"